module.exports = __webpack_public_path__ + "img/calendar-regular-red.dfa9f657.svg";